module.exports = __webpack_public_path__ + "static/img/Arrafi Maulana-full.6f62b29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/full/Arrafi Maulana-full.png
// module id = rqk6
// module chunks = 1